import { memo } from 'react';
import { markdownFirstLine } from './markdownFirstLine';

interface MarkdownCellProps {
  value: unknown;
}

/**
 * Display cell for a `markdown` column: one line of plain text (see
 * `markdownFirstLine`); the cell wrapper's `truncate` ellipsizes it.
 */
export const MarkdownCell = memo(function MarkdownCell({ value }: MarkdownCellProps) {
  if (value == null || value === '') return null;
  const text = markdownFirstLine(String(value));
  if (!text) return null;
  return <span className="text-muted-foreground">{text}</span>;
});
